import { getGrowthBookOverrideFlags } from './getGrowthBookOverrideFlags';

export const handleGrowthBookOverrides = (gbInstance) => {
  const originalPayload = gbInstance.getPayload();
  try {
    /**
     * Example User-Agent with feature flags:
     * Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36 X-AQA-Feature-Flags-Override=feature-flag-1:true;feature-flag-2:true
     */
    const flagsString = getGrowthBookOverrideFlags(window?.navigator?.userAgent);
    if (!flagsString) return;
    
    const newOverrides = flagsString
      .split(';')
      .filter(Boolean) // Remove empty entries
      .reduce((overrideFlags, currentFlag) => {
        // Support both colon and equals separators
        const separator = currentFlag.includes(':') ? ':' : '=';
        const [key, value] = currentFlag.split(separator);
        if (key && value !== undefined) {
          overrideFlags[key] = { defaultValue: value === 'true' };
        }
        return overrideFlags;
      }, {});
      
    if (!newOverrides||!Object.keys(newOverrides)?.length) return;
    
    gbInstance.setPayload({
      ...originalPayload,
      features: {
        ...originalPayload.features,
        ...newOverrides,
      },
    });
  } catch {
    gbInstance.setPayload(originalPayload);
  }
};
